// eslint-disable-next-line import/prefer-default-export
export enum ManagementDashboardTab {
  Summary = 0,
  Org = 1,
  Team = 2,
  CustomSP = 3,
  Reports = 4,
}
